<template>
  <div class="ecosystem-modules-toggle">
    <template v-if="available">
      <b-form-checkbox
        v-for="module in paidModules"
        :key="module.key"
        :id="id + '-' + module.key"
        v-model="checkedModules[module.key]"
        :disabled="savingModule !== null"
        switch
        @change="onToggle(module, $event)"
      >
        {{ module.label }}
      </b-form-checkbox>
      <!-- Keys keep v-translate from reusing the other branch's msgid (MOOV-5239) -->
      <small key="saved-right-away" class="form-text text-muted" v-translate>Each change is saved right away, without the Submit button.</small>
    </template>
    <small v-else key="not-available" class="form-text text-muted" v-translate>Not available yet.</small>
  </div>
</template>

<script>
// Switches for the paid modules of an ecosystem (MOOV-5554), used through the engine's componentEdit.
// Each toggle is saved on its own with PUT /ecosystems/{id}/modules/{module}: the form's PATCH never
// carries `modules`, since the field isn't editable.
export default {
  name: 'EcosystemModulesToggle',
  props: {
    // Names of the enabled modules, as GET /ecosystems/{id} returns them; missing on a backend without them
    value: {
      type: Array,
      default: undefined
    },
    ecosystemId: {
      type: Number,
      default: null
    },
    id: {
      type: String,
      default: 'ecosystem-modules'
    }
  },
  data() {
    return {
      // Local copy of the switches, so a cancelled or failed toggle can be put back
      checkedModules: {},
      savingModule: null
    }
  },
  computed: {
    // Same catalog as the backend's EcosystemModule::ALL
    paidModules() {
      return [{ key: 'carriers', label: this.$gettext('Carriers') }]
    },
    available() {
      return Array.isArray(this.value) && this.ecosystemId !== null
    }
  },
  watch: {
    value: {
      handler() {
        this.resetChecked()
      },
      immediate: true
    }
  },
  methods: {
    resetChecked() {
      const enabled = Array.isArray(this.value) ? this.value : []
      this.checkedModules = this.paidModules.reduce((checked, module) => {
        checked[module.key] = enabled.includes(module.key)
        return checked
      }, {})
    },
    onToggle(module, enabled) {
      const warning = enabled
        ? this.$gettext('Enable %{module} for this ecosystem? Its users will be able to use it right away.')
        : this.$gettext(
            "Disable %{module} for this ecosystem? Its carrier users won't be able to log in or operate, and the back office won't be able to assign tours to carriers."
          )
      if (!confirm(this.$gettextInterpolate(warning, { module: module.label }))) {
        this.resetChecked()
        return
      }
      this.savingModule = module.key
      this.$http
        .put(this.$appConfig.api.baseUrl + 'ecosystems/' + this.ecosystemId + '/modules/' + module.key, { enabled })
        .then(
          response => {
            this.$emit('input', response.body.modules)
          },
          () => {
            // The global interceptor already shows the backend's error
            this.resetChecked()
          }
        )
        .finally(() => {
          this.savingModule = null
        })
    }
  }
}
</script>
